module.exports = __webpack_public_path__ + "img/xtxt.432852d8.png";